import { Outlet } from 'react-router-dom';
import './app.layout.css';

function AppLayout() {
    return (
        <div className="app-layout">
            <header className="app-header">
                <div className="app-header__brand">
                    <img
                        className="app-header__logo"
                        src="https://cdn.best-start.org/images/logos/bs-logo-white-250x86.png"
                        alt="BestStart"
                    />
                </div>
            </header>
            <main className="app-main">
                <Outlet />
            </main>
        </div>
    );
}

export default AppLayout;
